import { Controller } from '@hotwired/stimulus';

// Generic Turbo-submit button: swaps an icon for a spinner while the
// enclosing form's submission is pending, and reverts on failure.
export default class extends Controller {
  static targets = ['button', 'icon', 'spinner'];

  clicked() {
    this.iconTarget.classList.add('hidden');
    this.spinnerTarget.classList.remove('hidden');
  }

  submitStart() {
    this.buttonTarget.disabled = true;
  }

  submitEnd(event) {
    if (event.detail.success) return;

    this.buttonTarget.disabled = false;
    this.iconTarget.classList.remove('hidden');
    this.spinnerTarget.classList.add('hidden');
  }
}
